var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flat-pickr',_vm._g({ref:"datepicker",attrs:{"value":_vm.value,"config":_vm.datepickerConfig,"name":_vm.name}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }